import { render, staticRenderFns } from "./RegisteredStore.vue?vue&type=template&id=8b1e3068&scoped=true&"
import script from "./RegisteredStore.vue?vue&type=script&lang=js&"
export * from "./RegisteredStore.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredStore.vue?vue&type=style&index=0&id=8b1e3068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1e3068",
  null
  
)

export default component.exports